export const SET_IS_LOADING = 'setIsLoading';
export const setIsLoading = (loadingState: boolean) => ({
    type: SET_IS_LOADING,
    payload: loadingState,
});
